import { isSafari } from 'react-device-detect';


export const isSafariBrowser = () => isSafari
